/* LUFFKA - header and announcement line (sections/luffka-header.liquid,
   sections/luffka-announcement.liquid).

   - Fold: past the top row the header gets .is-folded (the slim bar's small
     logo and icons slide in). The space is kept by CSS, so nothing shifts.
   - Hover/focus: pointing at an overlay header fills it with ivory
     (.is-lit). Menu links soften their siblings in CSS.
   - Product panel: opens on hover (with a short close delay so the pointer
     can travel into it), on click or Enter; Escape and leaving close it.
   - Phones: the full-screen menu sheet.
   - Cart: the bar's cart link mirrors the count of the theme's
     #cart-icon-bubble and hands its click to the original link, so the
     theme's cart drawer opens from either.
   - Announcement: messages take turns; still under reduced motion. */
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeader(hdr) {
    if (hdr.dataset.ready) return;
    hdr.dataset.ready = '1';
    const root = document.documentElement;
    const top = hdr.querySelector('.lfk-hdr__top');
    const panel = hdr.querySelector('[data-lfk-panel]');
    const trigger = hdr.querySelector('[data-lfk-panel-trigger]');
    const dim = document.querySelector('[data-lfk-dim]');

    // Fold once the top row has scrolled away.
    let queued = false;
    const fold = () => {
      queued = false;
      const threshold = top && top.offsetHeight ? top.offsetHeight - 4 : 40;
      hdr.classList.toggle('is-folded', window.scrollY > threshold);
    };
    window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(fold); } }, { passive: true });
    fold();

    // Overlay: lit while pointed at, focused, folded or the panel is open.
    const lit = () => hdr.classList.toggle('is-lit', hdr.matches(':hover') || hdr.contains(document.activeElement) || (panel && panel.dataset.open === 'true'));
    hdr.addEventListener('mouseenter', lit);
    hdr.addEventListener('mouseleave', () => setTimeout(lit, 160));
    hdr.addEventListener('focusin', lit);
    hdr.addEventListener('focusout', () => setTimeout(lit, 0));

    // Product panel.
    let closeTimer = 0;
    const setPanel = (open) => {
      if (!panel || !trigger) return;
      clearTimeout(closeTimer);
      panel.dataset.open = String(open);
      trigger.setAttribute('aria-expanded', String(open));
      trigger.classList.toggle('is-open', open);
      if (dim) dim.classList.toggle('is-on', open);
      lit();
    };
    const closeSoon = () => { clearTimeout(closeTimer); closeTimer = setTimeout(() => setPanel(false), 140); };
    if (panel && trigger) {
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (canHover) {
        trigger.addEventListener('mouseenter', () => setPanel(true));
        panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
        hdr.addEventListener('mouseleave', closeSoon);
        hdr.querySelectorAll('.lfk-hdr__nav a').forEach((a) => a.addEventListener('mouseenter', closeSoon));
      }
      trigger.addEventListener('click', () => setPanel(panel.dataset.open !== 'true'));
      panel.addEventListener('focusout', (e) => { if (!panel.contains(e.relatedTarget) && e.relatedTarget !== trigger) setPanel(false); });
      if (dim) dim.addEventListener('click', () => setPanel(false));
    }

    // Phone sheet.
    const sheet = document.querySelector('[data-lfk-sheet]');
    const opener = hdr.querySelector('[data-lfk-sheet-open]');
    const setSheet = (open) => {
      if (!sheet) return;
      sheet.dataset.open = String(open);
      if (opener) opener.setAttribute('aria-expanded', String(open));
      root.classList.toggle('lfk-sheet-open', open);
      if (open) sheet.querySelector('a, button')?.focus({ preventScroll: true });
      else if (opener) opener.focus({ preventScroll: true });
    };
    if (opener) opener.addEventListener('click', () => setSheet(true));
    sheet?.querySelector('[data-lfk-sheet-close]')?.addEventListener('click', () => setSheet(false));

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (panel && panel.dataset.open === 'true') { setPanel(false); trigger?.focus(); }
      if (sheet && sheet.dataset.open === 'true') setSheet(false);
    });

    // Cart: mirror the count, forward the click to the theme's own link.
    const bubble = document.getElementById('cart-icon-bubble');
    const copy = hdr.querySelector('[data-lfk-bubble-copy]');
    const original = bubble && bubble.closest('a');
    if (bubble && copy) {
      const sync = () => { copy.innerHTML = bubble.innerHTML; };
      new MutationObserver(sync).observe(bubble, { childList: true, subtree: true, characterData: true });
      sync();
      const copyLink = copy.closest('a');
      copyLink?.addEventListener('click', (e) => {
        if (!original || !document.querySelector('cart-drawer')) return;
        e.preventDefault();
        original.click();
      });
    }
  }

  function initAnnounce(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    const msgs = [...box.querySelectorAll('.lfk-announce__msg')];
    if (msgs.length < 2 || reduce) return;
    let k = 0;
    let paused = false;
    box.addEventListener('mouseenter', () => { paused = true; });
    box.addEventListener('mouseleave', () => { paused = false; });
    setInterval(() => {
      if (paused || document.hidden) return;
      msgs[k].classList.remove('is-on');
      k = (k + 1) % msgs.length;
      msgs[k].classList.add('is-on');
    }, 4500);
  }

  function init() {
    document.querySelectorAll('[data-lfk-hdr]').forEach(initHeader);
    document.querySelectorAll('[data-lfk-announce]').forEach(initAnnounce);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
